import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ContractDataInterface } from '../data';
import { ContractProvider } from '../providers/contract.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetContractDataUseCase implements UseCase<Observable<Transaction<ContractDataInterface>>> {
    constructor(private contractProvider: ContractProvider) {}

    bind(): Observable<Transaction<ContractDataInterface>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) => this.contractProvider.data(contract.encryptedCode),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
